export default function getTags(userTags: string[], autoTags: string[], num: number, keyword?: string) {

  let result = "";
  let count = 0;

  let resultTags = [];

  if (keyword) {
    resultTags = resultTags.concat(userTags&&userTags.filter(tag => {
      return tag.includes(keyword)
    }));
    resultTags = resultTags.concat(autoTags&&autoTags.filter(tag => {
      return tag.includes(keyword)
    }));
    resultTags = resultTags.concat(userTags&&userTags.filter(tag => {
      return !tag.includes(keyword)
    }));
    resultTags = resultTags.concat(autoTags&&autoTags.filter(tag => {
      return !tag.includes(keyword)
    }));
  } else {
    resultTags = resultTags.concat(userTags);
    resultTags = resultTags.concat(autoTags);
  }

  resultTags.forEach(tag => {
      if (count < num) {
        result = addTag(result, tag);
        count++;
      } else {
        return;
      }
    });

    return count < resultTags.length ? result + "..." : result;
}

  function addTag(result, tag) {
    return result + "#" + tag + " ";
  }